module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#album",
      toString: function () {
        return this.url;
      }
    }